import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { UserInformationToggleActionProp } from "../../../../Type/DashboardType";
import { useState } from "react";
import { Delete, Edit } from "../../../../Constant";
import { useNavigate } from "react-router-dom";

export const UserInformationToggleAction = ({ deletHandler, id }: UserInformationToggleActionProp) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const naviagte = useNavigate();
  const toggle = () => setDropdownOpen(!dropdownOpen);

  return (
    <td>
      <Dropdown className="icon-dropdown" isOpen={dropdownOpen} toggle={toggle}>
        <DropdownToggle color="tranfparent" className="border-0">
          <i className="icon-more-alt"></i>
        </DropdownToggle>
        <DropdownMenu end>
          <DropdownItem onClick={() => naviagte("/users/edit-profile")}>{Edit}</DropdownItem>
          <DropdownItem className="dropdown-item remove" onClick={() => deletHandler(id)}>
            {Delete}
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </td>
  );
};
